module.exports = __webpack_public_path__ + "img/logo2.dc26d095.png";